/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/inbox/bulk/actions/update"/>
import * as ko from "knockout";
import { Action } from "Core/Medius.Core.Web/Scripts/Medius/apps/inbox/bulk/actions/action";
import * as globalization from "Core/Medius.Core.Web/Scripts/lib/globalization";
import { getMigratedTemplate } from "Core/Medius.Core.Web/Scripts/customTabs/customTabs";

export class Update extends Action {
    constructor(tasks: any) {
        super(tasks);
        this.id = "update";
        this.label = globalization.getLabelTranslation("#Core/bulkUpdateAction");
        this.isAvailable = ko.observable(false);
        this.isReady(false);

        const viewPath = resolveBulkUpdateViewPath(this.documentType, this.activity);
        this.isAvailable(!!viewPath);
        this.viewPath = viewPath;
        this.isReady(true);
    }
}

function resolveBulkUpdateViewPath(type: string, activityName: string): string | null {
        const candidatesPaths = [
            `Display/${type}/${activityName}`,
            `Display/${type}/BulkUpdate`
        ];

        for (const path of candidatesPaths) {
            if (getMigratedTemplate(path)) {
                return path;
            }
        }
        
        return null;
}
